import {getMethod, putMethod} from '~/api'

async function get(id, request) {
    return await getMethod(`/api/privateClients/${id}/settings`, request)
}

async function put(id, request) {
    return await putMethod(`/api/privateClients/${id}/settings`, request)
}

export {get, put}
